import React, { useState } from "react";

import "../../settings.styles.css";
import SettingsPanel from "../../components/SettingsPanel";

import VatPeriod from "./vatPeriod";
import YearEndPeriod from "./yearEndPeriod";

export default function AccountingPeriods() {
  const [activeTab, setActiveTab] = useState("2");

  const Tabs = [
    {
      id: "2",
      name: "VAT Periods",
      slug: "vat",
    },
    {
      id: "3",
      name: "Year End Periods",
      slug: "year-end",
    },
  ];

  return (
    <SettingsPanel
      title="Accounting Periods Settings"
      description="VAT return periods and year end periods used across accounting."
      tabs={Tabs.map((item) => ({
        value: item.id,
        label: item.name,
        slug: item.slug,
      }))}
      value={activeTab}
      onChange={setActiveTab}
    >
      {activeTab === "2" && <VatPeriod />}
      {activeTab === "3" && <YearEndPeriod />}
    </SettingsPanel>
  );
}
